
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();
  const [time, setTime] = useState(8);

  useEffect(() => {
    if (time === 0) navigate("/");
    const t = setTimeout(() => setTime(time - 1), 1000);
    return () => clearTimeout(t);
  }, [time, navigate]);

  useEffect(() => {
    const key = (e) => e.key.toLowerCase() === "h" && navigate("/");
    window.addEventListener("keydown", key);
    return () => window.removeEventListener("keydown", key);
  }, [navigate]);

  return (
    <>
      <style>{`
        .page{
          min-height:100vh;
          display:flex;
          align-items:center;
          justify-content:center;
          background:#f5f9ef;
          font-family:Segoe UI, sans-serif;
          padding:20px;
        }

        .container{
          width:100%;
          max-width:1100px;
          display:flex;
          align-items:center;
          justify-content:space-between;
          gap:40px;
        }

        .left{ flex:1; }

        .code{
          font-size:150px;
          font-weight:900;
          color:#8BC53F;
          line-height:1;
        }

        .title{
          font-size:32px;
          font-weight:700;
          margin-top:10px;
        }

        .desc{
          margin-top:10px;
          color:#555;
          line-height:1.6;
        }

        .timer{
          margin-top:15px;
          color:#8BC53F;
          font-weight:600;
        }

        .actions{
          margin-top:25px;
          display:flex;
          gap:15px;
          flex-wrap:wrap;
        }

        .btn{
          padding:12px 26px;
          border-radius:8px;
          cursor:pointer;
          font-weight:600;
          transition:.25s;
        }

        .home{
          background:#8BC53F;
          color:white;
          border:none;
        }

        .home:hover{ background:#6fa32c; }

        .back{
          border:2px solid #8BC53F;
          color:#8BC53F;
          background:transparent;
        }

        .back:hover{
          background:#8BC53F;
          color:white;
        }

        .visual{
          flex:1;
          min-height:260px;
          position:relative;
        }

        .circle{
          position:absolute;
          border-radius:50%;
          background:#8BC53F22;
          animation:float 6s infinite ease-in-out;
        }

        .c1{width:220px;height:220px;top:0;right:40px;}
        .c2{width:140px;height:140px;bottom:30px;right:0;}
        .c3{width:90px;height:90px;bottom:80px;left:40px;}

        @keyframes float{
          0%{transform:translateY(0)}
          50%{transform:translateY(-20px)}
          100%{transform:translateY(0)}
        }

        /* TABLET */
        @media (max-width: 900px){
          .code{font-size:120px;}
          .title{font-size:26px;}
          .container{gap:20px;}
        }

        @media (max-width: 600px){

        .page{
        align-items:center;
        }

        .container{
        flex-direction:column;
        justify-content:center;
        min-height:100vh;
        text-align:center;
        }

        .left{
        display:flex;
        flex-direction:column;
        justify-content:center;
        align-items:center;
        flex:1;
        }

        /* Move animation to bottom */
        .visual{
        order:2;
        height:160px;
        margin-top:20px;
        }

        .code{font-size:100px;}
        .title{font-size:22px;}
        .desc{font-size:14px;}

        .actions{
        justify-content:center;
        }

        .c1{width:160px;height:160px;}
        .c2{width:100px;height:100px;}
        .c3{width:70px;height:70px;}
        }


      `}</style>

      <div className="page">
        <div className="container">

          <div className="left">
            <div className="code">404</div>
            <div className="title">We can't find that page</div>

            <div className="desc">
              The page may have been moved or deleted.
              Try going back or return to the homepage.
            </div>

            <div className="timer">
              Redirecting in {time}s (Press H for Home)
            </div>

            <div className="actions">
              <button className="btn home" onClick={() => navigate("/")}>
                Go Home
              </button>

              <button className="btn back" onClick={() => navigate(-1)}>
                Go Back
              </button>
            </div>
          </div>

          <div className="visual">
            <div className="circle c1"></div>
            <div className="circle c2"></div>
            <div className="circle c3"></div>
          </div>

        </div>
      </div>
    </>
  );
}
